import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "validation-table-excel-reorder-dialog__content" }
const _hoisted_2 = { class: "validation-table-excel-reorder-dialog__item" }
const _hoisted_3 = { class: "validation-table-excel-reorder-dialog__pos" }
const _hoisted_4 = { class: "validation-table-excel-reorder-dialog__text" }
const _hoisted_5 = {
  key: 0,
  class: "validation-table-excel-reorder-dialog__overlay"
}
const _hoisted_6 = { class: "validation-table-excel-reorder-dialog__overlay-title" }
const _hoisted_7 = { class: "validation-table-excel-reorder-dialog__overlay-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_draggable = _resolveComponent("draggable")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.visible,
    header: _ctx.title,
    modal: "",
    closable: !_ctx.dndInitializing,
    style: { width: '26rem' },
    "onUpdate:visible": _ctx.onVisibleChange
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_draggable, {
          modelValue: _ctx.localRows,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localRows) = $event)),
          "item-key": "$id",
          handle: ".validation-table-excel-reorder-dialog__handle",
          class: "validation-table-excel-reorder-dialog__list",
          disabled: _ctx.readonly || _ctx.dndInitializing,
          onEnd: _ctx.onDragEnd
        }, {
          item: _withCtx(({ element }) => [
            _createElementVNode("div", _hoisted_2, [
              _cache[1] || (_cache[1] = _createElementVNode("i", { class: "mdi mdi-drag validation-table-excel-reorder-dialog__handle" }, null, -1)),
              _createElementVNode("span", _hoisted_3, _toDisplayString(element.rowPosition), 1),
              _createElementVNode("span", _hoisted_4, _toDisplayString(element.preview), 1)
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "disabled", "onEnd"]),
        (_ctx.dndInitializing)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_ProgressSpinner, {
                strokeWidth: "4",
                animationDuration: ".8s",
                class: "validation-table-excel-reorder-dialog__spinner"
              }),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.t('Squeeze.Validation.General.TableV2InitializingTitle')), 1),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.t('Squeeze.Validation.General.TableValidationInitializing')), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["visible", "header", "closable", "onUpdate:visible"]))
}